export enum MESSAGE_TYPE {
  DEFAULT = 'DEFAULT',
  DANGER = 'DANGER',
}
